import { Avatar, IconButton } from "@mui/material";
import React, { useState } from "react";
import { Box } from "@mui/system";
import { useAppContext } from "context";
import Drawer from "../../layout/Drawer";
import Profile from "./profile/Profile";
import CompanyProfile from "./CompanyProfile";
import LanguageSwitcher from "./LanguageSwitcher";

const Header = () => {
  const { authUser } = useAppContext();
  const [openProfile, setOpenProfile] = useState(false);

  const handleProfile = () => {
    setOpenProfile(!openProfile);
  };

  return (
    <>
      <Box
        className="flex items-center w-[100%]"
        sx={{ justifyContent: "space-between" }}
      >
        {/* <Box
          className="ml-[10px] text-gray"
          sx={{
            display: { md: "block", xs: "none" },
          }}
        >
          <img
            className="h-[40px]"
            src={
              authUser && authUser.org && authUser.org.logo
                ? authUser.org.logo
                : no_img
            }
            alt="Logo"
          />
        </Box> */}
        <CompanyProfile />
        <div className="flex items-center">
          <LanguageSwitcher />
          <div>
            <IconButton
              onClick={handleProfile}
              size="small"
              aria-controls="account-menu"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <Avatar
                alt="profile-pic"
                src={authUser.photo}
                className="!bg-transparent !border border-primary-400"
              />
            </IconButton>
          </div>
        </div>
      </Box>

      <Drawer {...{ open: openProfile, setOpen: setOpenProfile }}>
        <Profile {...{ setOpen: setOpenProfile, open: openProfile }} />
      </Drawer>
    </>
  );
};

export default Header;
